// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","actionsArea":"_2sy3DDj9fO0fxZ2c3BWta-","likeButton":"_3FwicVHk9Cqzvu8Dpe9Zb6","liked":"igECROfAYLEYSuQnWSmyp"};